import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['toggle', 'hide'];
  static values = {
    key: String,
    target: String,
    mode: 'radio' // 'radio', 'checkbox', 'button', radio hides all but the selected, checkbox toggles the visibility of the selected
  };

  connect() {
    if (!this.hasToggleTarget) {
      console.warn('This Controller needs a toggle target');
      return;
    }

    this.toggleTargets.forEach((toggleTarget) => {
      if (this.modeValue === 'button') {
        // Initial state
        this.updateIcon(toggleTarget.dataset.toggleVisibilityTargetValue, true);

        // Toggle on click
        toggleTarget.addEventListener('click', (event) => {
          const toggleVisibilityTargetValue =
            event.target.dataset.toggleVisibilityTargetValue;

          if (toggleVisibilityTargetValue) {
            this.toggleVisibility(toggleVisibilityTargetValue);
            this.updateIcon(toggleVisibilityTargetValue, false);
          }
        });
      } else {
        // Initial state
        if (toggleTarget.checked) {
          this.toggleVisibility(toggleTarget.value);
        }

        // Toggle on change
        toggleTarget.addEventListener('change', (event) => {
          if (this.modeValue === 'radio') {
            this.toggleVisibility(event.target.value);
          } else if (this.modeValue === 'checkbox') {
            this.toggleVisibility(event.target.dataset.toggleVisibilityTargetValue);
          } else {
            console.warn('Unknown mode', this.modeValue);
          }
        });
      }
    });
  }

  toggleVisibility(targetValue) {
    this.hideTargets.forEach((hideTarget) => {
      switch (this.modeValue) {
        case 'radio':
          hideTarget.hidden = hideTarget.dataset.toggleVisibilityKeyValue !== targetValue;
          break;
        case 'checkbox':
        case 'button':
          if (hideTarget.dataset.toggleVisibilityKeyValue == targetValue) {
            hideTarget.hidden = !hideTarget.hidden;
          }
          break;
        default:
          console.warn('Unknown mode', this.modeValue);
          break;
      }
      hideTarget.classList.toggle('hidden');
    });
  }

  updateIcon(target, init) {
    const toggleButtonTarget = document.querySelector(`#${target}-toggle-icon`);
    const is_open = toggleButtonTarget.getAttribute('data-open') === 'true';

    const new_state = init ? is_open : !is_open;
    toggleButtonTarget.setAttribute('data-open', new_state);
    toggleButtonTarget.style.transform = new_state ? 'rotate(0deg)' : 'rotate(-90deg)';
  }
}
